<template>
    <div :style="messageColors" class="sc-message--system">
        <slot :message="data">
            <span v-html="processedText" style="word-break: break-word; max-width: 475px" />
            <span v-if="data.meta" :style="{ color: messageColors.color }" class="sc-message--meta">
                {{ data.meta }}</span
            >
        </slot>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
        processedText() {
            let text = this.data.text;
            const userIds = text.match(/\b[0-9a-fA-F]{24}\b/g);
            if (userIds) {
                userIds.forEach(id => {
                    const user = this.users.find(user => user._id === id);
                    if (user) {
                        text = text.replace(id, user.name);
                    }
                });
            }
            return text;
        }
    },
};
</script>

<style scoped>
.sc-message--system {
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 12px;
    line-height: 1.2;
    -webkit-font-smoothing: subpixel-antialiased;
    font-style: italic;
    opacity: 0.75;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
    word-break: break-word;
}

.sc-message--meta {
    font-size: xx-small;
    margin-bottom: 0;
    margin-top: 5px;
    opacity: 0.5;
    text-align: center;
}
</style>
